<template>
  <div>
    <div>
      <div
        class="relative grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
      >
        <slot v-bind="{ onLayout }"></slot>
      </div>
    </div>
    <slot name="masonry:footer"></slot>
  </div>
</template>

<script>
// import MiniMasonry from "minimasonry";

export default {
  data() {
    return {
      masonry: null,
    };
  },
  methods: {
    onLayout() {
      if (!this.masonry) return;
      // this.masonry.layout();
      // setTimeout(() => {
      //   this.masonry.layout();
      // }, 100);
    },
  },
  // mounted() {
  //   this.masonry = new MiniMasonry({
  //     container: this.$refs?.container,
  //     baseWidth: 400,
  //   });
  // },
};
</script>

<style scoped>
.masonry {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: masonry;
  gap: 1rem;
}
</style>
